import * as qs from 'query-string'
import {CONSTANTS} from './pages/new-view-services-with-data/constants'
import {getServicePerformanceFlags} from '@telstra-connect/service-performance/feature-flags/load-flags'
export default class Route {
  public static get ServicePerformance(): string {
    return '/service-performance'
  }

  public static get PerformanceStatus(): string {
    return 'sites-services-status'
  }

  public static PerformanceServicesTab(object = {queryStringObj: null}): string {
    const enableLandingPageReDesign = getServicePerformanceFlags().enableLandingPageReDesign

    const basePath = 'sites-services-status/services'
    const {queryStringObj} = object
    if (queryStringObj) {
      const pathWithQueryString = qs.stringify(queryStringObj, {
        arrayFormat: 'separator',
        arrayFormatSeparator: '|',
        skipNull: true,
        skipEmptyString: true,
      })
      const urlsearchparams = new URLSearchParams(pathWithQueryString)
      const timerange = urlsearchparams.get('timerange')
      const productNames = urlsearchparams.get('productNames')
      const locations = urlsearchparams.get('locations')
      const status = urlsearchparams.get('status')
      const searchTerms = urlsearchparams.get('searchTerms')
      const urlParamsOld = new URLSearchParams(window.location.search)
      if (timerange) urlParamsOld.set('timerange', timerange)
      if (timerange === CONSTANTS.DELETE_PARAMS) urlParamsOld.delete('timerange')
      if (productNames) urlParamsOld.set('productNames', productNames)
      if (productNames === CONSTANTS.DELETE_PARAMS) urlParamsOld.delete('productNames')
      if (locations) urlParamsOld.set('locations', locations)
      if (locations === CONSTANTS.DELETE_PARAMS) urlParamsOld.delete('locations')
      if (status) urlParamsOld.set('status', status)
      if (status === CONSTANTS.DELETE_PARAMS) urlParamsOld.delete('status')
      if (searchTerms) urlParamsOld.set('searchTerms', searchTerms)
      if (searchTerms === CONSTANTS.DELETE_PARAMS) urlParamsOld.delete('searchTerms')
      return enableLandingPageReDesign
        ? `${basePath}?${urlParamsOld}`
        : `${basePath}?${pathWithQueryString}`
    }
    return basePath
  }
  public static get ServicesWithoutPerformanceDataTab(): string {
    return 'sites-services-status/services-list'
  }

  public static get PerformanceSitesTab(): string {
    return 'sites-services-status/sites'
  }

  public static get ServicesDetailsBySiteRoute(): string {
    return 'sites/:siteId/services'
  }

  public static ViewServicesDetailsBySite(siteId: string): string {
    return this.ServicesDetailsBySiteRoute.replace(':siteId', siteId)
  }

  public static get ServiceDetail() {
    return 'services/:serviceId/priority/:priority/detail'
  }

  public static ViewServiceDetail(serviceId: string, priority: string) {
    return this.ServiceDetail.replace(':serviceId', encodeURIComponent(serviceId)).replace(
      ':priority',
      encodeURIComponent(priority),
    )
  }

  public static get ServiceDetailInt() {
    return 'services/:serviceId/detail'
  }

  public static ViewServiceDetailInt(
    serviceId: string,
    selectedCidn?: string,
    parentServiceID?: string,
  ): string {
    if (selectedCidn) {
      if (parentServiceID) {
        const pathValue = `services/:serviceId/detail?selectedCidn=${selectedCidn}&parentServiceID=${parentServiceID}`
        return pathValue
          .replace(':serviceId', encodeURIComponent(serviceId))
          .replace(':parentServiceID', encodeURIComponent(parentServiceID))
      }
      return `services/:serviceId/detail?selectedCidn=${selectedCidn}`.replace(
        ':serviceId',
        encodeURIComponent(serviceId),
      )
    } else {
      return this.ServiceDetailInt.replace(':serviceId', encodeURIComponent(serviceId))
    }
  }

  public static get ServiceDetailBySiteID(): string {
    return 'services/:siteId/:serviceId/priority/:priority/detail'
  }

  public static ViewServiceDetailBySiteId(
    siteId: string,
    serviceId: string,
    priority: string,
  ): string {
    return this.ServiceDetailBySiteID.replace(':siteId', siteId)
      .replace(':serviceId', encodeURIComponent(serviceId))
      .replace(':priority', encodeURIComponent(priority))
  }

  public static get SubmitABugURL(): string {
    return '/app/support/error-report'
  }

  public static supportCreateEnquiry(): string {
    return '/customer-support/new-enquiry'
  }

  public static supportTrackEnquiry(): string {
    return '/tracking/enquiries'
  }

  public static createRequest(): string {
    return '/service-requests/your-products-and-services'
  }

  public static trackRequest(): string {
    return '/tracking/requests'
  }

  public static imsCreateincidents(): string {
    return '/incidents/new-incident'
  }

  public static imsTrackincidents(): string {
    return '/tracking/incidents?source=card&action=status'
  }

  public static get RouteManagementDetailInt(): string {
    return 'route-management'
  }
  public static get AddPrefix(): string {
    return 'route-management/add-prefix'
  }
  public static get RouteManagementSuccessInt(): string {
    return 'routesuccess'
  }
  public static trackRequestInt(): string {
    return '/app/tracking/requests'
  }
  public static get AddDnsRecordRoute(): string {
    return 'add-dns-record'
  }
  public static get DNSManagementDetailInt(): string {
    return 'dns-management'
  }
  public static get AdaptiveNetworksDetailInt(): string {
    return 'services/:category'
  }
  public static get AllServices(): string {
    return 'services/all-services'
  }
  public static getAdaptiveNetworksDetailInt(category): string {
    return this.AdaptiveNetworksDetailInt.replace(':category', category)
  }
  public static get DnsRequestSuccessInt(): string {
    return 'dns-success'
  }
  public static supportFaqUrl(): string {
    return '/support/faq'
  }
  public static supportEnquiriesUrl(): string {
    return '/customer-support/new-enquiry'
  }
  public static trackRequestUrl(): string {
    return '/tracking/requests'
  }
  public static get yourProductsServicesInt(): string {
    return 'your-products-and-services'
  }
}
